/* eslint-disable @typescript-eslint/no-explicit-any */
import underscore from 'underscore';

declare global {
  interface Window {
    context: string | { [key: string]: any };
  }
}

/**
 * Parsing json string django context passing to html i.e.
 * in python: render(request, template name, context={'context': json.dumps(some_object)})
 * in js: djangoContextHelper() -> context object
 */
const djangoContextHelper = <T>(): { user?: string | null; data?: T } => {
  if (typeof window.context === 'string') {
    let contextStr = window.context;
    try {
      contextStr = underscore.unescape(contextStr);
      contextStr = contextStr.replaceAll('\r', '').replaceAll('\n', '\\n');
      window.context = JSON.parse(contextStr) as { user: string | null; data: T };
    } catch (err) {
      console.error('Failed to parse django context', err);
      console.error('Context:', contextStr);
      window.context = {};
    }
    return window.context;
  }
  return window.context;
};

export default djangoContextHelper;
